import api from '../index'

export interface AiEmployeeConsoleLaunchConfig {
  project_code: string
  console_url: string
  bootstrap: {
    navigation: Array<{ key: string, path: string, title: string, icon: string }>
    [key: string]: any
  }
}

export interface AiEmployeeConsoleRequest {
  method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'
  path: string
  workspace_key?: string
  params?: object
  data?: object
  headers?: Record<string, string>
}

export function createAiEmployeeConsoleApi(prefix = '/aiEmployee') {
  return {
    getLaunchConfig: (): Promise<{ data: AiEmployeeConsoleLaunchConfig }> => api.get(`${prefix}/getConsoleLaunchConfig`),
    request: (request: AiEmployeeConsoleRequest): Promise<{ data: unknown }> => {
      const path = request.path.startsWith('/') ? request.path : `/${request.path}`
      if (!/^\/aiEmployee\/(?:brain|console)\//.test(path)) {
        return Promise.reject(new Error('AI员工接口路径无效'))
      }

      const idempotencyKey = request.headers?.['Idempotency-Key']
      return api.request({
        method: request.method,
        url: path.replace(/^\/aiEmployee\//, `${prefix}/`),
        params: request.params,
        data: request.data,
        headers: {
          'X-AI-Employee-Workspace-Key': request.workspace_key,
          ...(idempotencyKey ? { 'Idempotency-Key': idempotencyKey } : {}),
        },
      })
    },
  }
}

export default createAiEmployeeConsoleApi()
